function buildGiftStatusHistory (gift) {
  const history = []
  if (!gift) {
    return history
  }
  if (gift.dateCreated) {
    history.push({ status: 'pending', date: gift.dateCreated })
  }
  if (gift.dateAccepted) {
    history.push({ status: 'accepted', date: gift.dateAccepted })
    return history
  }
  if (gift.dateCancelled) {
    const declined = !!(gift.giftMetadata && gift.giftMetadata.cancelledBy === 'recipient')
    history.push({
      status: declined ? 'declined' : 'cancelled',
      date: gift.dateCancelled
    })
  }
  return history
}

module.exports = {
  buildGiftStatusHistory
}
